import { render, staticRenderFns } from "./DiscountRuleEditor.vue?vue&type=template&id=204f2623&scoped=true&"
import script from "./DiscountRuleEditor.vue?vue&type=script&lang=js&"
export * from "./DiscountRuleEditor.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRuleEditor.vue?vue&type=style&index=0&id=204f2623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f2623",
  null
  
)

export default component.exports